// import React, { useEffect, useRef, useState } from "react";
// import MyCartStepper from "../components/Steppers/MyCartStepper";
// import MyCartStep from "../components/StepperRenderComponents/MyCartStep";
// import UploadPrescriptionStep from "../components/StepperRenderComponents/UploadPrescriptionStep";
// import AddressStep from "../components/StepperRenderComponents/AddressStep";
// import OrderSummaryStep from "../components/StepperRenderComponents/OrderSummaryStep";
// import PaymentStep from "../components/StepperRenderComponents/PaymentStep";
// import { useSelector } from "react-redux";
// import { FaArrowLeftLong } from "react-icons/fa6";
// import { apiGET, apiPOST, apiPUT } from "../utilities/apiHelpers";
// import { API_URL } from "../config";
// import scrollToTop from "../utilities/scrollToTop";
// import { useLocation } from "react-router-dom";
// import { toast } from "react-toastify";

// const ViewCart = () => {
//     const location = useLocation();
//     const prevLocationRef = useRef(location.pathname);
//     const userId = useSelector((state) => state.user?.userData.id) || '';
//     const [stepperProgressCartData, setStepperProgressCartData] = useState([]);
//     const [globalConfig, setGlobalConfig] = useState([]);
//     const steps = [
//         'My Cart',
//         'Upload Prescription',
//         'Add Address',
//         'Order Summary',
//         'Payment'
//     ];


//     const goToPrevStep = async () => {
//         if (stepperProgressCartData?.currentStep > 0) {
//             const payload = {
//                 currentStep: stepperProgressCartData?.currentStep - 1
//             }
//             const response = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
//             console.log(response.data.data);
//             setStepperProgressCartData(response?.data?.data);
//         }
//     };

//     const renderStepComponent = (stepIndex) => {
//         switch (stepIndex) {
//             case 0:
//                 return <MyCartStep stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} globalConfig={globalConfig} />;
//             case 1:
//                 return <UploadPrescriptionStep type="cart" stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} globalConfig={globalConfig} />;
//             case 2:
//                 return <AddressStep stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} globalConfig={globalConfig} />;
//             case 3:
//                 return <OrderSummaryStep stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} globalConfig={globalConfig} />;
//             case 4:
//                 return <PaymentStep stepperProgressCartData={stepperProgressCartData} setStepperProgressCartData={setStepperProgressCartData} globalConfig={globalConfig} />;
//             default:
//                 return null;
//         }
//     };

//     const getUserStepperProgress = async () => {
//         try {
//             const userStepperResponse = await apiGET(`${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`);
//             if (userStepperResponse?.data?.code == 400 && !userStepperResponse?.data?.status) {
//                 const stepperProgressAddPayload = {
//                     orderMode: 'order'
//                 }
//                 const userStepperAddResponse = await apiPOST(`${API_URL}/v1/stepper-progress/add-stepper-progress/${userId}`, stepperProgressAddPayload);
//                 console.log("userStepperAddResponse", userStepperAddResponse);
//                 setStepperProgressCartData(userStepperAddResponse.data?.data);
//             }
//             else {
//                 setStepperProgressCartData(userStepperResponse.data?.data);
//             }
//             console.log("response", userStepperResponse);
//         } catch (error) {
//             console.error("Error fetching or creating stepper progress:", error);
//         }
//     }

//     const resetCurrentStep = async () => {
//         const payload = {
//             currentStep: 0
//         }
//         const response = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
//         if (response.status) {
//             console.log('resetCurrentStep', response.data.data);
//             setStepperProgressCartData(response?.data?.data);
//         } else {
//             toast.error("Error Updating the user stepper");
//         }
//     }

//     const fetchGlobalConfig = async () => {
//         try {
//             const response = await apiGET(`/v1/global-config/get-config`);
//             if (response.status) {
//                 console.log(response?.data?.data?.data[0]);
//                 setGlobalConfig(response?.data?.data?.data[0]);
//             } else {
//                 toast.error('Error fetching global config')
//             }
//         } catch (error) {
//             toast.error('Error', error)
//         }
//     }
//     useEffect(() => {
//         scrollToTop();
//         fetchGlobalConfig();
//         getUserStepperProgress();
//     }, [])

//     useEffect(() => {
//         if (prevLocationRef.current !== location.pathname) {
//             resetCurrentStep();
//             prevLocationRef.current = location.pathname;
//         }
//     }, [location.pathname]);

//     return <div className="container mx-auto lg:p-4 p-2">
//         <MyCartStepper steps={steps} currentStep={stepperProgressCartData?.currentStep} />
//         {
//             stepperProgressCartData?.currentStep > 0 && <button
//                 onClick={goToPrevStep}
//                 className="flex items-center justify-start gap-2 mt-2">
//                 <FaArrowLeftLong />Back to {steps[stepperProgressCartData?.currentStep - 1]}
//             </button>
//         }
//         {renderStepComponent(stepperProgressCartData?.currentStep)}
//     </div >
// }

// export default ViewCart; 

import React, {
    useEffect,
    useRef,
    useState,
    useCallback
} from "react";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { toast } from "react-toastify";

import MyCartStepper from "../components/Steppers/MyCartStepper";
import MyCartStep from "../components/StepperRenderComponents/MyCartStep";
import UploadPrescriptionStep from "../components/StepperRenderComponents/UploadPrescriptionStep";
import AddressStep from "../components/StepperRenderComponents/AddressStep";
import OrderSummaryStep from "../components/StepperRenderComponents/OrderSummaryStep";
import PaymentStep from "../components/StepperRenderComponents/PaymentStep";

import { apiGET, apiPOST, apiPUT } from "../utilities/apiHelpers";
import { API_URL } from "../config";
import scrollToTop from "../utilities/scrollToTop";

const ViewCart = () => {
    const location = useLocation();
    const prevLocationRef = useRef(location.pathname);

    const userId =
        useSelector((state) => state.user?.userData?.id) || "";

    const [stepperProgressCartData, setStepperProgressCartData] = useState({});
    const [globalConfig, setGlobalConfig] = useState({});

    const steps = [
        "My Cart",
        "Upload Prescription",
        "Add Address",
        "Order Summary",
        "Payment",
    ];

    /* ================================
       FETCH STEPPER PROGRESS
    ================================= */
    const getUserStepperProgress = useCallback(async () => {
        if (!userId) return;

        try {
            const res = await apiGET(
                `${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`
            );

            if (res?.data?.code === 400 && !res?.data?.status) {
                const createPayload = { orderMode: "order" };
                const createRes = await apiPOST(
                    `${API_URL}/v1/stepper-progress/add-stepper-progress/${userId}`,
                    createPayload
                );
                setStepperProgressCartData(createRes?.data?.data || {});
            } else {
                setStepperProgressCartData(res?.data?.data || {});
            }
        } catch (error) {
            console.error("Stepper fetch error:", error);
        }
    }, [userId]);

    /* ================================
       FETCH GLOBAL CONFIG
    ================================= */
    const fetchGlobalConfig = useCallback(async () => {
        try {
            const res = await apiGET(`/v1/global-config/get-config`);
            if (res.status) {
                setGlobalConfig(res?.data?.data?.data?.[0] || {});
            } else {
                toast.error("Error fetching global config");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error fetching global config");
        }
    }, []);

    /* ================================
       RESET STEPPER ON ROUTE CHANGE
    ================================= */
    const resetCurrentStep = useCallback(async () => {
        if (!userId) return;

        try {
            const payload = { currentStep: 0 };
            const res = await apiPUT(
                `${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`,
                payload
            );
            if (res.status) {
                setStepperProgressCartData(res?.data?.data || {});
            } else {
                toast.error("Error updating stepper");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error resetting stepper");
        }
    }, [userId]);

    /* ================================
       GO TO PREVIOUS STEP
    ================================= */
    const goToPrevStep = async () => {
        if (stepperProgressCartData?.currentStep > 0) {
            try {
                const payload = {
                    currentStep: stepperProgressCartData.currentStep - 1,
                };
                const res = await apiPUT(
                    `${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`,
                    payload
                );
                setStepperProgressCartData(res?.data?.data || {});
                if (res?.data?.data) {
                    window.location.reload();
                }
            } catch (error) {
                console.error("Previous step error:", error);
            }
        }
    };

    /* ================================
       RENDER STEPS
    ================================= */
    const renderStepComponent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return (
                    <MyCartStep
                        stepperProgressCartData={stepperProgressCartData}
                        setStepperProgressCartData={setStepperProgressCartData}
                        globalConfig={globalConfig}
                    />
                );
            case 1:
                return (
                    <UploadPrescriptionStep
                        type="cart"
                        stepperProgressCartData={stepperProgressCartData}
                        setStepperProgressCartData={setStepperProgressCartData}
                        globalConfig={globalConfig}
                    />
                );
            case 2:
                return (
                    <AddressStep
                        stepperProgressCartData={stepperProgressCartData}
                        setStepperProgressCartData={setStepperProgressCartData}
                        globalConfig={globalConfig}
                    />
                );
            case 3:
                return (
                    <OrderSummaryStep
                        stepperProgressCartData={stepperProgressCartData}
                        setStepperProgressCartData={setStepperProgressCartData}
                        globalConfig={globalConfig}
                    />
                );
            case 4:
                return (
                    <PaymentStep
                        stepperProgressCartData={stepperProgressCartData}
                        setStepperProgressCartData={setStepperProgressCartData}
                        globalConfig={globalConfig}
                    />
                );
            default:
                return null;
        }
    };

    /* ================================
       INITIAL LOAD
    ================================= */
    useEffect(() => {
        scrollToTop();
        fetchGlobalConfig();
        getUserStepperProgress();
    }, [fetchGlobalConfig, getUserStepperProgress]);

    /* ================================
       ROUTE CHANGE LISTENER
    ================================= */
    useEffect(() => {
        if (prevLocationRef.current !== location.pathname) {
            resetCurrentStep();
            prevLocationRef.current = location.pathname;
        }
    }, [location.pathname, resetCurrentStep]);

    /* ================================
       UI
    ================================= */
    return (
        <div className="container mx-auto lg:p-4 p-2">
            <MyCartStepper
                steps={steps}
                currentStep={stepperProgressCartData?.currentStep}
            />

            {stepperProgressCartData?.currentStep > 0 && (
                <button
                    onClick={goToPrevStep}
                    className="group bg-gray-200 text-[#14967F] hover:bg-[#14967F] hover:text-white mb-2  flex items-center gap-2 mt-4 px-4 py-2 text-sm font-medium  transition-all duration-200 rounded-lg active:scale-95"
                >
                    <FaArrowLeftLong className="transition-transform duration-200 group-hover:-translate-x-1" />
                    <span>Back to {steps[stepperProgressCartData.currentStep - 1]}</span>
                </button>
            )}

            {renderStepComponent(stepperProgressCartData?.currentStep)}
        </div>
    );
};

export default ViewCart;

